import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react'
import { SelectList, SelectTitle } from '../../MissionCreatePage/MissionCreatePageStyled'
import { UploadFileListItem, UploadFileListWrapper } from './WorkCreatePageStyled'
import {
  Button, Col, DatePicker, Form, Input, message, Row, Select, Space, Tag, Tooltip, Upload, Tabs
} from 'antd'
import {
  BankOutlined, CloseOutlined, DeleteOutlined, EditOutlined, FileTextOutlined,
  TeamOutlined, UploadOutlined, UserOutlined
} from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import { ASSIGNEE_TYPE, DATE_FORMAT_LIST, WORK_STATUS } from '../../../constants'
import moment from 'moment'
import { blue, yellowPrimary } from '../../../color'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import { AvatarHasName } from '../../../components/Common/Avatar'
import RichEditor from '../../../components/RichEditor/RichEditor'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'
import validator from '../../../validator'
import commandStore from '../../../stores/commandStore'
import DashboardLayout from '../../../layouts/DashboardLayout/DashboardLayout'
import PageTitle from '../../../components/PageTitle'
import { Helmet } from 'react-helmet/es/Helmet'
import { systemName } from '../../../config'

const { Option } = Select
const { TabPane } = Tabs

const WorkCreatePage = props => {
  const {
    fileStore,
    workStore,
    loadingAnimationStore,
    selectPeopleStore,
  } = props

  const location = useLocation()
  const queryStringParsed = useMemo(() => queryString.parse(location.search), [location.search])
  const history = useHistory()
  const { workTypeList } = workStore

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    clearSelected,
  } = selectPeopleStore

  const [form] = Form.useForm()
  const EDITOR_REF = useRef()

  const [editorContent, setEditorContent] = useState(null)
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [fileList, setFileList] = useState([])
  const [fileFromDocumentList, setFileFromDocumentList] = useState([])

  useEffect(() => {
    selectPeopleStore.clearSelected()
  }, [])

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    const incoming_number = queryStringParsed.incoming_number || ''
    const title = queryStringParsed.document_title || ''
    const comments_leader = queryStringParsed.comments_leader?.length
      ? queryStringParsed.comments_leader
      : ''
    const leader_name =
      queryStringParsed.leader_name &&
        queryStringParsed.comments_leader?.length > 0
        ? `Đ/c ${queryStringParsed.leader_name}: `
        : ''
    if (queryStringParsed.document_code) {
      form.setFieldsValue({
        work_type: WORK_STATUS.DOCUMENT,
        title: `Xử lý văn bản ${incoming_number ? 'đến ' + incoming_number : 'đi'
          }: ${title}`,
        content: `Nội dung: ${title + '. \n'}${leader_name} ${comments_leader}`,
        start_date: moment(),
      })
      setEditorContent(`Nội dung: ${title + '. \n'}${leader_name} ${comments_leader}`)
      const files = queryStringParsed.document_list
        ? (Array.isArray(queryStringParsed.document_list)
          ? queryStringParsed.document_list
          : [queryStringParsed.document_list]).map(file => ({
            file_id: file.split('/')[0],
            file_name: file.split('/').slice(1).join(),
          }))
        : []
      setFileFromDocumentList(files)
    }
    if (queryStringParsed.mission_code) {
      form.setFieldsValue({
        work_type: WORK_STATUS.DEPLOY,
      })
    }

    if (!form.getFieldValue('work_type')) {
      form.setFieldsValue({
        work_type: WORK_STATUS.OTHER,
      })
    }
  }, [queryStringParsed])

  const handleChangeFile = useCallback(info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const handleRemoveFileFromDocumentList = file_id => {
    const newFileList = fileFromDocumentList.filter(
      file => file.file_id !== file_id
    )
    setFileFromDocumentList(newFileList)
  }

  const handleCancel = () => {
    history.replace('/works')
    selectPeopleStore.clearSelected()
  }

  const onFinish = async value => {
    if (handlerList.length === 0)
      return message.warning('Bạn chưa chọn người xử lý công việc!')
    const assigneesList = [...followerList, ...handlerList].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    const { title, start_date, due_date, work_type } = value
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })

    try {
      loadingAnimationStore.showSpinner(true)
      const response = await Promise.all(batchUploadArr)
      const dataSubmit = {
        title: title,
        start_date: start_date,
        related_documents:
          queryStringParsed.document_code && queryStringParsed.document_type
            ? [
              {
                code: queryStringParsed.document_code,
                type: queryStringParsed.document_type,
              },
            ]
            : [],
        related_tasks: queryStringParsed.mission_code && [
          queryStringParsed.mission_code,
        ],
        due_date: due_date,
        content: EDITOR_REF.current.editor.getData(),
        attachments: response
          .map(response => response.data.file_id)
          .concat(fileFromDocumentList.map(file => file.file_id)),
        assignees: assigneesList,
        work_type: work_type,
      }
      await workStore.createWork(dataSubmit)

      workStore.clearQueryParams()
      workStore.clearWorkList()
      await workStore.getWorkList()

      clearSelected()
      message.success('Tạo công việc thành công!')
      history.replace('/works')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
      commandStore.getSideMenuCounter([
        'WORK',
        'PROPOSAL',
        'INTERNAL_MESSAGE',
        'INCOMING',
        'OUTGOING',
        'ELEC_DOC'
      ])
    }
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tạo công việc mới | {systemName} Công việc</title>
      </Helmet>
      <PageTitle location={location} />

      <div style={{ padding: '0 24px', maxWidth: '100%' }}>
        <h2 style={{ fontSize: 24, fontWeight: 600, marginBottom: 24, color: '#262626' }}>
          Tạo công việc mới
        </h2>

        <Form onFinish={onFinish} form={form} layout="vertical">
          <div style={{
            background: '#fafafa',
            borderRadius: 8,
            padding: 24,
            marginBottom: 24,
            border: '1px solid #f0f0f0'
          }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16, color: '#262626' }}>
              Thông tin chung
            </h3>

            <Form.Item
              style={{ display: 'none' }}
              label={'Loại công việc'}
              name={'work_type'}
            >
              <Select>
                {workTypeList.map(workType => (
                  <Option key={workType.id} value={workType.id}>
                    {workType.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={
                <span>
                  <span style={{ color: '#ff4d4f', marginRight: 4 }}>*</span>
                  <span style={{ fontWeight: 500 }}>Tiêu đề:</span>
                </span>
              }
              required={false}
              name={'title'}
              rules={[
                { required: true, message: 'Vui lòng nhập tiêu đề' },
                { max: 499, message: 'Tiêu đề đã đủ 500 ký tự, không thể nhập thêm!' },
                { validator: validator.validateInputString },
              ]}
            >
              <Input maxLength={500} placeholder={'Nhập tiêu đề...'} style={{ borderRadius: 6 }} size="large" />
            </Form.Item>

            <Row gutter={[24, 16]}>
              <Col span={12}>
                <Form.Item
                  label={
                    <span>
                      <span style={{ color: '#ff4d4f', marginRight: 4 }}>*</span>
                      <span style={{ fontWeight: 500 }}>Ngày bắt đầu:</span>
                    </span>
                  }
                  required={false}
                  rules={[{ required: true, message: 'Vui lòng chọn ngày bắt đầu!' }]}
                  name={'start_date'}
                >
                  <DatePicker format={DATE_FORMAT_LIST} style={{ width: '100%', borderRadius: 6 }} size="large" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={<span style={{ fontWeight: 500 }}>Ngày kết thúc:</span>}
                  name={'due_date'}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startDate = getFieldValue('start_date')
                        if (!startDate || !value) return Promise.resolve()
                        if (value.isAfter(startDate)) return Promise.resolve()
                        return Promise.reject('Ngày kết thúc phải lớn hơn ngày bắt đầu!')
                      },
                    }),
                  ]}
                >
                  <DatePicker format={DATE_FORMAT_LIST} style={{ width: '100%', borderRadius: 6 }} size="large" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[24, 16]}>
              <Col span={12}>
                <SelectTitle style={{ marginBottom: 12 }}>
                  <div className="ant-form-item-label" style={{ padding: 0 }}>
                    <label>
                      <span>
                        <span style={{ color: '#ff4d4f', marginRight: 4 }}>*</span>
                        <span style={{ fontWeight: 500, marginRight: 10 }}>Người xử lý:</span>
                      </span>
                    </label>
                  </div>
                  <Space>
                    <Tooltip title="Chọn người dùng" color={blue}>
                      <Button
                        icon={<UserOutlined style={{ color: blue }} />}
                        onClick={() => handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.HANDLER)}
                        style={{ borderRadius: 6 }}
                      />
                    </Tooltip>
                    <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                      <Button
                        icon={<TeamOutlined />}
                        style={{ color: yellowPrimary, borderRadius: 6 }}
                        onClick={() => handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)}
                      />
                    </Tooltip>
                  </Space>
                </SelectTitle>
                <SelectList>
                  {handlerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}
                    >
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && <BankOutlined />) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
                        }
                      />
                    </Tag>
                  ))}
                </SelectList>
              </Col>

              <Col span={12}>
                <SelectTitle style={{ marginBottom: 12 }}>
                  <div className="ant-form-item-label" style={{ padding: 0 }}>
                    <label>
                      <span>
                        <span style={{ fontWeight: 500, marginRight: 10 }}>Người theo dõi:</span>
                      </span>
                    </label>
                  </div>
                  <Space>
                    <Tooltip title="Chọn người dùng" color={blue}>
                      <Button
                        icon={<UserOutlined style={{ color: blue }} />}
                        onClick={() => handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)}
                        style={{ borderRadius: 6 }}
                      />
                    </Tooltip>
                    <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                      <Button
                        icon={<TeamOutlined />}
                        style={{ color: yellowPrimary, borderRadius: 6 }}
                        onClick={() => handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)}
                      />
                    </Tooltip>
                  </Space>
                </SelectTitle>
                <SelectList>
                  {followerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}
                    >
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && <BankOutlined />) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
                        }
                      />
                    </Tag>
                  ))}
                </SelectList>
              </Col>
            </Row>
            <Tabs defaultActiveKey="1" style={{ marginTop: 24 }}>
              <TabPane tab="Nội dung" key="1">
                <Form.Item label={<span style={{ fontWeight: 500 }}>Nội dung:</span>} name={'content'} style={{ marginBottom: 24, marginTop: 16 }}>
                  <RichEditor
                    EDITOR_REF={EDITOR_REF}
                    placeholder={'Nhập nội dung...'}
                    editorContent={editorContent}
                  />
                </Form.Item>
              </TabPane>

              <TabPane tab="Tài liệu đính kèm" key="2">
                <Form.Item name={'id_file_dinh_kem'} style={{ marginBottom: 16, marginTop: 16 }}>
                  <Upload
                    valuePropName={'fileList'}
                    fileList={fileList}
                    multiple={true}
                    onChange={handleChangeFile}
                    beforeUpload={() => false}
                    showUploadList={false}
                  >
                    <Button htmlType={'button'} icon={<UploadOutlined />} style={{ borderRadius: 6 }}>
                      Chọn tài liệu đính kèm
                    </Button>
                  </Upload>
                </Form.Item>

                {fileFromDocumentList.length !== 0 && (
                  <UploadFileListWrapper>
                    {fileFromDocumentList.map(file => (
                      <UploadFileListItem key={file.file_id}>
                        <FileTextOutlined style={{ color: blue }} />
                        <span
                          onClick={() => fileStore.handleDownloadFile(file.file_id, file.file_name)}
                          style={{ color: blue, cursor: 'pointer', textDecoration: 'underline' }}
                        >
                          {file.file_name}
                        </span>
                        <Tooltip title={'Xoá tập tin'}>
                          <DeleteOutlined onClick={() => handleRemoveFileFromDocumentList(file.file_id)} />
                        </Tooltip>
                      </UploadFileListItem>
                    ))}
                  </UploadFileListWrapper>
                )}

                {fileList.length !== 0 && (
                  <UploadFileListWrapper>
                    {fileList.map(file => (
                      <UploadFileListItem key={file.uid}>
                        <FileTextOutlined />
                        <span>{file.name}</span>
                        <Tooltip title={'Xoá tập tin'}>
                          <DeleteOutlined onClick={() => handleRemoveFileFromUploadList(file.uid)} />
                        </Tooltip>
                      </UploadFileListItem>
                    ))}
                  </UploadFileListWrapper>
                )}
              </TabPane>
            </Tabs>
          </div>

          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32, paddingBottom: 40, gap: 16 }}>
            <Button
              size="large"
              style={{ minWidth: 120, borderRadius: 8, color: '#ff4d4f', borderColor: '#ff4d4f' }}
              onClick={() => {
                handleCancel()
              }}
            >
              Hủy
            </Button>
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              style={{ minWidth: 120, borderRadius: 8 }}
            >
              Tạo mới
            </Button>
          </div>
        </Form>

        <SelectPeoplePopup
          id={'create-work-select-people-popup'}
          handleCancelSelectUser={handleCancelSelectUserDepartment}
          handleSubmitSelectUser={() => setIsVisibleSelectUserDepartmentPopup(false)}
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        />
        <SelectGroupPopup
          id={'create-work-select-group-popup'}
          isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
          handleCancelSelectGroup={handleCancelSelectGroup}
          handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
        />
      </div>

      <style>{`
        .ant-tabs-nav::before {
          border-bottom: 1px solid #f0f0f0;
        }
        .ant-tabs-tab {
          font-weight: 500;
        }
      `}</style>
    </DashboardLayout>
  )
}

export default inject(
  'selectPeopleStore',
  'fileStore',
  'workStore',
  'loadingAnimationStore'
)(observer(WorkCreatePage))
